module.exports = __webpack_public_path__ + "img/privileges.149b96e9.svg";